import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { formatApiError } from "../lib/auth";
import { Toaster, toast } from "sonner";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (!token) {
        return (
            <div className="min-h-[60vh] grid place-items-center p-10 text-center">
                <div>
                    <h1 className="font-display text-3xl">Ongeldige link</h1>
                    <p className="text-zinc-500 mt-2">Vraag een nieuwe reset link aan.</p>
                    <Link to="/forgot-password" className="btn-primary mt-6 inline-block">Nieuwe link</Link>
                </div>
            </div>
        );
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { toast.error("Wachtwoorden komen niet overeen"); return; }
        if (password.length < 6) { toast.error("Min. 6 tekens"); return; }
        setSubmitting(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Wachtwoord gewijzigd! Log nu in.");
            setTimeout(() => navigate("/login"), 1200);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="reset-password-page" className="min-h-[80vh] grid place-items-center px-6 py-12 bg-zinc-50">
            <Toaster />
            <div className="w-full max-w-md card p-8">
                <p className="label-tiny">Nieuw wachtwoord</p>
                <h1 className="font-display text-4xl mt-2">Stel een nieuw in.</h1>
                <form onSubmit={onSubmit} className="mt-8 space-y-4">
                    <div>
                        <label className="label-tiny block mb-2">Nieuw wachtwoord (min 6 tekens)</label>
                        <input data-testid="reset-password-input" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} className="input-flat" />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">Bevestig wachtwoord</label>
                        <input data-testid="reset-confirm-input" type="password" minLength={6} required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-flat" />
                    </div>
                    <button data-testid="reset-submit" type="submit" disabled={submitting} className="btn-primary w-full">
                        {submitting ? "Bezig…" : "Wachtwoord wijzigen"}
                    </button>
                </form>
            </div>
        </div>
    );
}
